// chartConfig2.js  实时课堂分析  折线图配置文件
export const chartOption1 = {
    title: {
      text: '教师注意力分析'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['互动', '讲授', '演示']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: ['00：00', '00：05', '00：10', '00：15', '00：20', '00：25', '00：30', '00：35', '00：40', '00：45', '00：50']
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: '互动',
        type: 'line',
        stack: 'Total',
        data: [120, 132, 101, 134, 90, 230, 210,100,200,150,188]
      },
      {
        name: '讲授',
        type: 'line',
        stack: 'Total',
        data: [220, 182, 191, 234, 290, 330, 310,101, 134, 90, 230]
      },
      {
        name: '演示',
        type: 'line',
        stack: 'Total',
        data: [150, 232, 201, 154, 190, 330, 210,191, 234, 290, 330, 310]
      },
    
    ]
  };

  export const chartOption2 = {
    title: {
      text: '教师授课相关度分析'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['相关度分析']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: ['2024-3-09', '2024-3-15', '2024-4-09', '2024-5-09', '2024-6-09', '2024-7-09', '2024-8-15']
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: '相关度分析',
        type: 'line',
        stack: 'Total',
        data: [40, 32, 32, 34, 50, 28, 60]
      },
     
    ]
  };

  export const chartOption3 = {
    // title: {
    //   text: '课堂互动分布'
    // },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)' // 显示百分比
    },
    legend: {
      top: '5%',
      left: 'center'
    },
    series: [
      {
        name: '课堂互动分布',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: true, // 显示标签
          formatter: '{b}: {d}%' // 标签格式为名称: 百分比
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 20,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: true // 显示标签的引导线
        },
        data: [
          { value: 43, name: '讨论' , itemStyle: { color: '#249eff' }},
          { value: 21, name: '提问' },
          { value: 24, name: '实验' ,itemStyle: { color: '#6399ca' } },
          { value: 8, name: '测验' },
          { value: 4, name: '其他' , itemStyle: { color: '#313ca9' } }
        ]
      }
    ]
  };
  